module.exports = "/_next/static/images/Frame2-684c4e51d9a3b33131df2c1f86196301.png";